(function() {
  'use strict';

  angular
    .module('contentPlayer.cModuleOutro', ['factories.utils'])
    .controller('CModuleOutroCtrl', CModuleOutroCtrl);

  CModuleOutroCtrl.$inject = ['$scope', 'Utils', '$modal', 'SpinnerHelper', 'yammerService', '$window', 'gettext',
    'translationService', 'Auth', 'ContentPlayerService', 'PreviewContentPlayerService', 'Navigation', 'mtypes'];

  function CModuleOutroCtrl($scope, Utils, $modal, SpinnerHelper, yammerService, $window, gettext, translationService,
                            Auth, ContentPlayerService, PreviewContentPlayerService, Navigation, mtypes) {
    var translate = translationService.sprintf;
    var navigation = $scope.navigation;
    var playerGetCompletionInfo;
    var progressStatusDereg;
    var completionInfoDereg;

    $scope.isTrainerAsUserPreview = navigation.playerType === navigation.playerTypes.trainerAsUserPreview;
    $scope.state = {
      passedFailedText: '',
      scoreValueClass: '',
      showYammer: $scope.yammerInfo && $scope.yammerInfo.userCanSendYam && !$scope.isPreview && !$scope.isTrainerAsUserPreview
    };

    progressStatusDereg = $scope.$on('$progressProcessingCompleted', function() {
      if (!_.isEmpty(ContentPlayerService.serviceStatus)) {
        return;
      }
      callGetCompletionInfo();
    });

    function setup() {
      $scope.completionInfo = null;

      playerGetCompletionInfo = ContentPlayerService.getCompletionInfo;
      if ($scope.isPreview) {
        playerGetCompletionInfo = PreviewContentPlayerService.getCompletionInfo;
        callGetCompletionInfo();
        return;
      }

      if (!_.isEmpty(ContentPlayerService.serviceStatus)) {
        return;
      }

      callGetCompletionInfo();

      if ($scope.isTrainerAsUserPreview) {
        Navigation.intercept('canNavigate', function interceptCanNavigate(navigateTo) {
          return navigateTo === navigation.directions.previous;
        });
      }
    }

    function callGetCompletionInfo() {
      progressStatusDereg();
      playerGetCompletionInfo($scope.cModuleId, function completionSuccess(result) {
        $scope.completionInfo = result;
        if($scope.completionInfo.nextCModuleId) {
          navigation.setNextCModuleUrl('#/player/module/' + $scope.completionInfo.nextCModuleId + '/course/' + $scope.completionInfo.courseId);
        } else {
          navigation.resetNextCModuleUrl();
        }
      });
    }

    completionInfoDereg = $scope.$watch('completionInfo', function(newValue) {
      if (!newValue) {
        return;
      }

      if ($scope.isPreview) {
        $scope.finalGrade = 'xx';
        $scope.state.scoreValueClass = 'scorePassed';
        $scope.state.passedFailedText = gettext('You met the requirements for this module.');
        return;
      }

      $scope.finalGrade = $scope.completionInfo.finalGrade;
      $scope.state.isPublicCModule = navigation.playerType === navigation.playerTypes.public;

      if ($scope.completionInfo.cModulePassed) {
        $scope.state.passedFailedText = gettext('You met the requirements for this module.');
        $scope.state.scoreValueClass = 'scorePassed';
      } else {
        $scope.state.passedFailedText = gettext('You did not meet the requirements for this module.');
        $scope.state.scoreValueClass = 'scoreFailed';
      }
    });

    $scope.getSeriesCompletionText = function() {
      var completionText;

      if (!$scope.completionInfo) {
        return;
      }

      completionText = translate(gettext('You\'ve finished')) + ' ' +
        $scope.completionInfo.numberOfCompletedCModules + ' ' +
        translate(gettext('of')) + ' ' +
        $scope.completionInfo.numberOfCModules + ' ' +
        translate(gettext('modules in this course'));

      if ($scope.completionInfo.numberOfCompletedCModules === $scope.completionInfo.numberOfCModules ||
        $scope.completionInfo.nextCModuleType === mtypes.cModuleType.live ||
        !$scope.completionInfo.nextCModuleId) {
        completionText += '.';
        return completionText;
      }

      completionText += ' ' + translate(gettext('and are ready to start:'));
      return completionText;
    };

    $scope.getSeriesNextCModuleLink = function() {
      if (!$scope.completionInfo) {
        return;
      }

      return '#/player/module/' + $scope.completionInfo.nextCModuleId + '/course/' + $scope.completionInfo.courseId;
    };

    $scope.showSeriesNextCModuleLink = function() {
      return $scope.completionInfo &&
        $scope.completionInfo.nextCModuleTitle &&
        $scope.completionInfo.nextCModuleType !== mtypes.cModuleType.live;
    };

    $scope.getQuizPassFailClass = function(quizPassed) {
      return quizPassed ? 'quiz-passed' : 'quiz-failed';
    };

    $scope.emailTrainer = function() {
      Utils.email($scope.cModule.trainerEmail);
    };

    $scope.onCertificateButtonClick = function() {
      var account;
      var certificateUrl = $scope.completionInfo.certificateURL;
      if ($scope.isPreview) {
        account = Auth.getSelectedAccount();
        certificateUrl = certificateUrl + '?c=' + $scope.cModule.id + '&u=' + account.userId + '&pm=cModulePreview&qs=100';
      }

      Utils.downloadCertificate(certificateUrl);
    };

    $scope.yammerShare = function() {
      SpinnerHelper.showMinorSpinner();
      yammerService.getYammerInfoForCModule($scope.cModule.id, function(yammerInfo) {
        SpinnerHelper.hideAllSpinners();
        $scope.yammerCModuleInfo = yammerInfo;
        $modal.open({ templateUrl: 'contentPlayer/yammerShare.html', controller: 'YammerShareCtrl', scope: $scope });
      }, function(err) {
        SpinnerHelper.hideAllSpinners();
        return true;
      });
    };

    $scope.showQuizScore = function() {
      if (!$scope.completionInfo || !$scope.completionInfo.quizScores) {
        return false;
      }
      return $scope.completionInfo.quizScores.length > 0 && !$scope.state.isPublicCModule;
    };

    $scope.showScoQuizScore = function() {
      if (!$scope.completionInfo || !$scope.completionInfo.scoQuizScores) {
        return false;
      }
      return $scope.completionInfo.scoQuizScores.length > 0 && !$scope.state.isPublicCModule;
    };

    $scope.onSignUpWithMindflashClick = function() {
      Utils.viewUrl('https://www.mindflash.com/sign-up');
      Utils.kissmetrics('Clicked Start trial on module outro', null);
    };

    setup();

    $scope.$on('$destroy', function() {
      progressStatusDereg();
      completionInfoDereg();
    });
  }
})();
